import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Search input that reports its value after the user pauses typing; Esc or the cross clears it. */
export function SearchBox({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const { t } = useTranslation();
  const [local, setLocal] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => local !== value && onChange(local), 250);
    return () => clearTimeout(id);
  }, [local]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => setLocal(value), [value]);
  return (
    <div className="relative w-full min-w-48 sm:w-72">
      <Search className="pointer-events-none absolute start-3 top-1/2 size-4 -translate-y-1/2 text-ink-3" aria-hidden />
      <input className="field rounded-full border-transparent bg-paper ps-9 pe-8 focus:bg-surface [&::-webkit-search-cancel-button]:hidden" type="search" placeholder={t("common.searchPlaceholder")} value={local}
        onChange={(e) => setLocal(e.target.value)} onKeyDown={(e) => { if (e.key === "Escape" && local) { setLocal(""); onChange(""); } }} aria-label={t("common.search")} />
      {local && (
        <button type="button" className="absolute end-1.5 top-1/2 flex size-6 -translate-y-1/2 items-center justify-center rounded text-ink-3 hover:bg-line-2 hover:text-ink"
          aria-label={t("common.clear")} onClick={() => { setLocal(""); onChange(""); }}>
          <X className="size-3.5" aria-hidden />
        </button>
      )}
    </div>
  );
}
